import { externalCoursesEnrolledListWatcherSaga } from './list.saga'

export const root = [externalCoursesEnrolledListWatcherSaga()]

export default root
